import { style } from '@vanilla-extract/css'

const heading = style({
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const list = style({
  fontFamily: 'Noto Sans JP',
  fontSize: '15px',
  lineHeight: '1.5',
  listStyle: 'disc',
  paddingLeft: '1em',
})

const warn = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#ED0006',
})

const checkbox = style({
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

export const styles = {
  heading,
  list,
  warn,
  checkbox,
}
